/**********************************************************************
// @@@ START COPYRIGHT @@@
// AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
// Copyright 2018 - 2019
// Avi Solar Energy Pvt Ltd.
// Protected as an unpublished work.
// The computer program listings, specifications and documentation
// herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
// and shall not be reproduced, copied, disclosed, or used in whole or in part for
// any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
**********************************************************************/
<template>
  <Tabs :selected="active_tab" @change="(val) => active_tab = val" centered>
    <v-tab class="activeTab" center ripple v-for="tab of tabs" :key="tab.id">
      {{ $t(tab.name) }}
    </v-tab>
    <v-tab-item>
      <Card flat>
        <v-card-text class="pa-0">
          <BlockList :blockData="invLevelData" @totalGen="(val)=> $emit('totalGen', val)"/>
        </v-card-text>
      </Card>
    </v-tab-item>
    <v-tab-item>
      <Card flat>
        <v-card-text class="pa-0">
          <DipReason :dateFrom="dateFrom" :dateTo="dateTo" />
        </v-card-text>
      </Card>
    </v-tab-item>
  </Tabs>
</template>

<script>
import {
  mapGetters,
  mapMutations
} from 'vuex'
const moment = require('moment')

import Inverter from '@/services/Inverter'
import {
  mapGettersMixin
} from '@/util/mixin/index'
import {
  EventBus
} from '@/services/event-bus'

const BlockList = () => import('@/components/dashboard-inverter/BlockList')
const DipReason = () => import('@/components/dashboard-inverter/DipReason')

export default {
  components: {
    BlockList,
    DipReason
  },
  props: {
    dateFrom: {
      type: String,
      default: ''
    },
    dateTo: {
      type: String,
      default: ''
    },
  },
  mixins: [ mapGettersMixin ],
  data() {
    return {
      invLevelData: [],
      active_tab: 0,
      tabs: [
        { id: 1, name: 'Block List' },
        { id: 2, name: 'Dip Reason' }
      ],
      block_selected: null
    }
  },
  computed: {
    ...mapGetters([
      'getSelectedPlantId'
    ]),
    watchChange() {
      return `${this.getSelectedPlantId} ${this.dateFrom} ${this.dateTo}`
    }
  },
  created() {
    EventBus.$on('graph-click', this.onManualAlert)
    this.setIntervalWithoutDelay(this.callAllApi)
  },
  beforeDestroy() {
    EventBus.$off('graph-click', this.onManualAlert)
    this.SET_MAP_REDIRECT_BLOCK(false)
  },
  methods: {
    ...mapMutations([
      'SET_PROGRESS_BAR',
      'SET_MAP_REDIRECT_BLOCK',
      'SET_LAST_CALL_TIME'
    ]),
    callAllApi() {
      let updateTime = moment().format('MM-DD-YYYY H:mm:ss')
      this.SET_LAST_CALL_TIME(updateTime)
      this.getGenerationData()
    },
    async getGenerationData() {
      try {
        this.SET_PROGRESS_BAR(true)
        if (this.getSelectedPlantId && this.dateFrom && this.dateTo) {
          let invResponse = await Inverter.fetchInvList(this.getSelectedPlantId, this.dateFrom, this.dateTo)
          this.SET_PROGRESS_BAR(false)
          this.invLevelData = invResponse.data.result
          this.$emit('blockData', this.invLevelData.map(item => {
            return {
              text: `${item.name} : ${item.gen} kWh`,
              value: item.id, 
            }
          }))
        }
        if (this.block_selected == null) {
          this.block_selected = this.invLevelData[0].id
        }
      } catch (err) {
        this.SET_PROGRESS_BAR(false)
      }
    },
    onManualAlert (value) {
      this.active_tab = 1
    }
  },
  watch: {
    watchChange() {
      this.block_selected = null // or NUll
      this.setIntervalWithoutDelay(this.callAllApi)
    },
    block_selected(val) {
      this.$emit('activeBlock', val)
    },
    isReload() {
      if (this.isReload) {
        this.setIntervalWithoutDelay(this.callAllApi)
      }
    }
  }
}
</script>

<style scoped>
  .activeTab:hover {
    background-color: var(--v-sixth-base);
  }

@media (max-width: 600px) {
  .pa-2 {
    padding: 0px !important;
  }
}

.main-background {
  background-color: #2a335a;
}

.theme--dark {
  width: -webkit-fill-available;
}
</style>
